import { Form } from "react-bootstrap";
import {
  CustomInput,
  ReactSelect,
  FileInputSecond,
} from "../../kits/Inputs/Inputs";
import CustomButton from "../../kits/button/CustomButton";

import EntranceType from "./EntranceType";
import ChooseType from "./ChooseType";
export default function DefineAttribute({
  changeAttributeData,
  data,
  addPropertyFunc,
}) {
  return (
    <div className="border rounded p-1 ">
      <div className=" d-flex flex-wrap ">
        <div className="col-6 col-md-4 px-1">
          <CustomInput
            label="عنوان"
            inputSize="lg"
            type="text"
            inputType="input"
            inputContainer=""
            inputClassName=""
            inputValue={data.title}
            onChangeFunc={(e) => {
              changeAttributeData(e.target.value, "title");
            }}
            // textErr={validationTxt.answers}
          />
        </div>
        <div className="col-6 col-md-4 px-1">
          <ReactSelect
            title="نوع "
            itemsList={[
              { value: "1", label: "ورودی" },
              { value: "2", label: "انتخابی" },
            ]}
            inputContainer=""
            inputSize="lg"
            inputValue={data?.attributeType}
            onChangeFunc={(e) => {
              changeAttributeData(e, "attributeType");
            }}
            textErr={""}
          />
        </div>
        <div className="col-6 col-md-4 px-1">
          <FileInputSecond
            id={`attribute-icon`}
            label="انتخاب عکس"
            onChangeFunc={(e) => {
              changeAttributeData(e.target.files[0], "file");
            }}
          />
        </div>
      </div>
      {data?.attributeType?.value == 1 && (
        <div className="col-12 col-sm-6 col-md-4 px-1">
          <EntranceType changeAttributeData={changeAttributeData} data={data} />
        </div>
      )}
      {data?.attributeType?.value == 2 && (
        <div className=" px-1">
          <ChooseType changeAttributeData={changeAttributeData} data={data} />
        </div>
      )}
      <div className="col-6 col-md-4 px-1 ms-2 mt-3">
        <Form.Check // prettier-ignore
          type="switch"
          id="custom-switch"
          label="قابل مشاهده توسط کاربر "
          style={{ fontSize: 14 }}
          onChange={() => {
            if (
              data.seen_by_user == undefined ||
              data.seen_by_user == false ||
              data.seen_by_user == ""
            ) {
              changeAttributeData(true, "seen_by_user");
            } else changeAttributeData(false, "seen_by_user");
          }}
        />
      </div>

      <div className="ms-auto px-1 d-flex align-items-center">
        <CustomButton
          color="success"
          size="medium"
          //   type="outline"
          state="normal"
          circle={false}
          className={"ms-auto mt-2"}
          onClick={() => addPropertyFunc()}
        >
          + ثبت
        </CustomButton>
      </div>
    </div>
  );
}
